<template>
    <ApprovedPayments></ApprovedPayments>
</template>
<script>
    import ApprovedPayments from '@/components/EmployeeApprovedPayments.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            ApprovedPayments
        }
    }
</script>